import Image from 'next/image';
import styles from './SingleTestimonial.module.scss';

const SingleTestimonial = ({testimonial, backgroundColor=false}) => {
    return ( 
        <section className={`${styles.singleTestimonial} ${styles[`singleTestimonial-${testimonial.color}`]}`}>

            <div className={styles.testimonial}>
                <div style={{backgroundColor}}>
                    <div>
                    </div>
                    <div className={styles.text}>
                        <p>{testimonial.quote}</p>
                        {testimonial.customer &&
                            <div className={styles.customer}>{testimonial.customer}</div>
                        }
                    </div>
                </div>
            </div>

        </section>
     );
}
 
export default SingleTestimonial;